import {
  ApproverDelegatee,
  type ApproverDelegateeConstructor,
} from '@webapp/core/entities/internal/ApproverDelegatee'

export interface NextApproverChoiceConstructor {
  id: number
  firstName: string
  lastName: string
  levelText: Nullable<string>
  approvalDelegatee: Nullable<ApproverDelegateeConstructor>
}

export class NextApproverChoice {
  readonly id: number
  readonly firstName: string
  readonly lastName: string
  readonly levelText: Nullable<string>
  readonly approvalDelegatee: Nullable<ApproverDelegatee>

  constructor(data: NextApproverChoiceConstructor) {
    this.id = data.id
    this.firstName = data.firstName
    this.lastName = data.lastName
    this.levelText = data.levelText || null
    this.approvalDelegatee = data.approvalDelegatee
      ? new ApproverDelegatee(data.approvalDelegatee)
      : null
  }

  get fullName(): string {
    return `${this.firstName} ${this.lastName}`
  }

  get displayLabel(): string {
    return this.levelText ? `${this.fullName} ${this.levelText}` : this.fullName
  }

  get hasApprovalDelegatee(): boolean {
    return this.approvalDelegatee !== null
  }
}
